const multisearchKey = 'multisearchKey';

const SearchMultisearchService = function SearchMultisearchService(Restangular, breakpointsService, $stateParams, LocalStorageWrapper) {
    this._api = Restangular.one('Search');
    this.breakpoints = breakpointsService;
    this._stateParams = $stateParams;
    this.localStorage = LocalStorageWrapper;
};

SearchMultisearchService.prototype.getMultisearchItems = function () {
    const items = this.localStorage.get(multisearchKey) || '';
    return items.split(',');
};

SearchMultisearchService.prototype.updateMultisearchItems = function (multisearchItems) {
    if (multisearchItems) {
        this.localStorage.set(multisearchKey, multisearchItems.join(','));
    }
};

SearchMultisearchService.prototype.isSearchTermPartOfMultisearchList = function (searchTerm, multisearchItems) {
    if (!this._stateParams.multisearchItems && !multisearchItems) {
        return false;
    }
    if (!this._stateParams.searchTerm && !searchTerm) {
        return false;
    }

    const searchPhrase = searchTerm || this._stateParams.searchTerm;
    const items = multisearchItems ? multisearchItems.split(',') : this._stateParams.multisearchItems.split(',');
    const listIndex = items.indexOf(searchPhrase);
    if (listIndex < 0) {
        return false;
    }

    return true;
};

SearchMultisearchService.prototype.isSearchMultisearch = function () {
    return this._stateParams.multisearchItems && this.isSearchTermPartOfMultisearchList();
};

module.exports = SearchMultisearchService;



// WEBPACK FOOTER //
// ./src/search/search-multisearch.service.js